import React, { useState, useCallback, useContext, useRef, useEffect } from "react";
import ReactDOM from "react-dom";
import Modal from "react-modal";
import { IntlProvider, FormattedMessage, injectIntl } from "react-intl";
import { ConfigContext } from "../../components/ConfigContextProvider";
import ReactTooltip from "react-tooltip";
import ArrowSx from "../../icon/arrow_sx.svg";

const ModalDetail = (props) => {
  const { detail, modalIsOpen, closeModal, onPrev, onNext } = props;
  const { ASSETS_URL } = useContext(ConfigContext);
  const chars = detail.characteristics && Object.keys(detail.characteristics);
  const modalNodeRef = useRef(null);
  const [modalRect, setModalRect] = useState(null);

  const measureModal = useCallback(() => {
    if (modalNodeRef.current) {
      setModalRect(modalNodeRef.current.getBoundingClientRect());
    }
  }, []);

  useEffect(() => {
    if (modalIsOpen) {
      setTimeout(measureModal, 50);
    } else {
      setModalRect(null);
    }
  }, [modalIsOpen, detail]);

  useEffect(() => {
    window.addEventListener('resize', measureModal);
    return () => window.removeEventListener('resize', measureModal);
  }, []);

  const arrowPrevStyle = modalRect ? { left: Math.max(4, modalRect.left - 48) } : {};
  const arrowNextStyle = modalRect ? { right: Math.max(4, window.innerWidth - modalRect.right - 48) } : {};

  return (
    <>
      {modalIsOpen && onPrev && modalRect && ReactDOM.createPortal(
        <button className="modalNav__btn modalNav__btn--prev" style={arrowPrevStyle} onClick={onPrev}>
          <img src={ArrowSx} className="modalNav__icon" />
        </button>,
        document.body
      )}
      {modalIsOpen && onNext && modalRect && ReactDOM.createPortal(
        <button className="modalNav__btn modalNav__btn--next" style={arrowNextStyle} onClick={onNext}>
          <img src={ArrowSx} className="modalNav__icon modalNav__icon--next" />
        </button>,
        document.body
      )}
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        contentRef={node => { modalNodeRef.current = node; }}
        className={"samplesModal"}
      >
        <div className="itemDetail">
          <button className="itemModal__btnClose" onClick={() => closeModal()}>
            ✕
          </button>

          <div className="itemDetail__imageWrapper">
            <img className="itemDetail__img" src={detail.img}></img>
          </div>

          <div className="itemDetail__detailPanel">
            <div className="itemDetailContent">
            <h2 className="itemDetail__title">{detail.name}</h2>
            <p
              className="itemDetail__description"
              dangerouslySetInnerHTML={{
                __html: detail.description,
              }}
            />

            {detail.composition && (
              <div className="itemDetail__section">
                <h3 className="itemDetail__titleSection">
                  <FormattedMessage id={"label.composizione"} />
                </h3>
                <p className="itemDetail__contentSection">
                  {detail.composition}
                </p>
              </div>
            )}

            {((detail.maintenance && detail.maintenance.length > 1) || (detail.maintenanceTxt && detail.maintenanceTxt.length > 1)) && (
              <div className="itemDetail__section">
                <h3 className="itemDetail__titleSection">
                  <FormattedMessage id={"label.manutenzione"} />
                </h3>
                <div className="itemDetail__wrapperIcons">
                  {detail &&
                    detail.maintenance.map((item, i) => (
                      <span key={"detail" + i}>
                        <span
                          data-tip={props.intl.formatMessage({
                            id: `maintenance${item}`,
                          })}
                          key={"icon" + i}
                          className={"iconMaintenance"}
                        >
                          <img src={`${ASSETS_URL}/maintenance/${item}.svg`} />
                        </span>
                        <ReactTooltip
                          className="tooltipSpecial"
                          static
                          place="bottom"
                          html={true}
                          effect={"solid"}
                          multiline
                        />
                      </span>
                    ))}
                </div>
                {detail.maintenanceTxt && <span className="itemDetail__maintenanceText" dangerouslySetInnerHTML={{
                __html: detail.maintenanceTxt,
              }} />}
              </div>
            )}

            {detail.characteristics && chars && chars.length > 0 &&(
              <div className="itemDetail__section">
                <div className="itemDetail__wrapperIcons itemDetail__characteristics">
                  <div className="itemDetail__characteristicColumn">
                    <div className="itemDetail__characteristicColumnBorder">
                      {chars &&
                        chars.map((key, index) => {
                          return (
                            index < Math.max(chars.length / 2) && (
                              <div
                                className="itemDetail__characteristicItem"
                                key={"itemCol" + index}
                              >
                                <span className="itemDetail__dt">
                                  {key != "" ? (
                                    <FormattedMessage id={key} />
                                  ) : (
                                    ""
                                  )}
                                </span>
                                <span className="itemDetail__dl">
                                  {String(detail.characteristics[key])
                                    .toLowerCase()
                                    .indexOf("voc") !== -1 ? (
                                    <FormattedMessage
                                      id={detail.characteristics[
                                        key
                                      ]}
                                    />
                                  ) : (
                                    detail.characteristics[key]
                                  )}
                                </span>
                              </div>
                            )
                          );
                        })}
                    </div>
                  </div>

                  <div className="itemDetail__characteristicColumn">
                    <div className="itemDetail__characteristicColumnBorder">
                      {chars &&
                        chars.map((key, index) => {
                          return (
                            index >= Math.max(chars.length / 2) && (
                              <div
                                className="itemDetail__characteristicItem"
                                key={"itemColb" + index}
                              >
                                <span className="itemDetail__dt">
                                  {key != "" ? (
                                    <FormattedMessage id={key} />
                                  ) : (
                                    ""
                                  )}
                                </span>
                                <span className="itemDetail__dl">
                                  {String(detail.characteristics[key])
                                    .toLowerCase()
                                    .indexOf("voc") !== -1 ? (
                                    <FormattedMessage
                                      id={detail.characteristics[
                                        key
                                      ]}
                                    />
                                  ) : (
                                    detail.characteristics[key]
                                  )}
                                </span>
                              </div>
                            )
                          );
                        })}
                    </div>
                  </div>
                </div>
              </div>
            )}

            {detail.certificazioni && detail.certificazioni.length > 0 && (
              <div className="itemDetail__section itemDetail__section--certificazioni">
                <div className="itemDetail__characteristicItem">
                  <span className="itemDetail__dt">
                    <FormattedMessage id={"label.certificazioni"} />
                  </span>
                  <span className="itemDetail__dl">
                    {detail.certificazioni.join(' ')}
                  </span>
                </div>
              </div>
            )}
            </div>
            <div className="itemDetail__variantsWrapper">
              {detail &&
                detail.variants.map((item, i) => (
                  <a
                    key={"itemVariant__link" + i}
                    className="itemVariant__link"
                    onClick={() => props.onClick(item)}
                  >
                    <div className="itemVariant">
                      <div className="itemVariant__imgWrapper">
                        <img src={item.img}></img>
                      </div>
                      <div className="itemVariant__title">{item.name}</div>
                    </div>
                  </a>
                ))}
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default injectIntl(ModalDetail);
